import { Outlet } from "react-router-dom";

import { FilterTransactionWaiverProvider } from "./filter-transaction-waiver/filter-transaction-waiver.context";
import './transaction-waiver.scss';

export function TransactionWaiver() {
  return (
    <div id="ShellTransactionWaiver" className="transaction-waiver">
       <FilterTransactionWaiverProvider>
        <Outlet />
      </FilterTransactionWaiverProvider>
    </div>
  );
}

export default TransactionWaiver;
